module.exports = __webpack_public_path__ + "img/emoticon-nps-1-off.a7505095.svg";